import { Outlet } from 'react-router';
import { NotFound } from '@britishcouncil/react-admin';
import { ROUTING_PATHS } from 'const';
import {
  CreateLrwSession,
  CreateSpeakingSession,
  LrwSessions,
  SpeakingSessions,
  ExamDatesForLocations,
  TestCentreOverview,
  SpeakingSessionDetails,
  LrwSessionDetails,
  AddRoomToSpeakingSession,
  LinkSpeakingSession,
  AddRoomToLrwSession,
  ReleaseLrwSession,
  ReleaseLrwWithSpeakingSession,
  ReleaseSpeakingSession,
  EditSpeakingSession,
  EditLrwSession,
  RemoveLrwSession,
  RemoveSpeakingSession,
  RemoveSpeakingSessionRoom,
  RemoveLrwSessionRoom,
  ManageExaminerToRoomStructure,
} from 'pages';
import { Dashboard } from './dashboard';

const {
  dashboard,
  speakingSessions,
  createSpeakingSession,
  lrwSessions,
  createLrwSession,
  examDatesForLocations,
  testCentreOverview,
  speakingSessionDetails,
  lrwSessionDetails,
  addRoomToSpeakingSession,
  linkSpeakingSession,
  addRoomToLrwSession,
  releaseLrwSession,
  releaseLrwWithSpeakingSessions,
  editSpeakingSessionRoom,
  releaseSpeakingSession,
  editSpeakingSession,
  editLrwSession,
  removeLrwSession,
  removeSpeakingSession,
  removeLrwSessionRoom,
  removeSpeakingSessionRoom,
  manageSpeakingSessionRoomStructureExaminer,
} = ROUTING_PATHS;

export const APP_ROUTES = [
  { path: dashboard, element: <Dashboard /> },
  {
    path: examDatesForLocations.absolutePath,
    element: <ExamDatesForLocations />,
  },
  {
    path: testCentreOverview.absolutePath,
    element: <TestCentreOverview />,
    filters: testCentreOverview.filters,
  },
  {
    path: speakingSessions.absolutePath,
    breadcrumb: { text: 'Speaking sessions' },
    element: <Outlet />,
    children: [
      {
        path: speakingSessions.path,
        element: (
          <>
            <Outlet />
            <SpeakingSessions />
          </>
        ),
        filters: speakingSessions.filters,
        children: [
          {
            path: createSpeakingSession.path,
            element: <CreateSpeakingSession />,
            filters: createSpeakingSession.filters,
          },
        ],
      },
      {
        path: speakingSessionDetails.path,
        breadcrumb: { text: 'View Speaking session' },
        element: <SpeakingSessionDetails />,
        filters: speakingSessionDetails.filters,
        children: [
          {
            path: addRoomToSpeakingSession.path,
            element: <AddRoomToSpeakingSession />,
            filters: addRoomToSpeakingSession.filters,
          },
          {
            path: manageSpeakingSessionRoomStructureExaminer.path,
            element: <ManageExaminerToRoomStructure />,
            filters: manageSpeakingSessionRoomStructureExaminer.filters,
          },
          {
            path: editSpeakingSessionRoom.path,
            filters: editSpeakingSessionRoom.filters,
          },
          {
            path: releaseSpeakingSession.path,
            element: <ReleaseSpeakingSession />,
            filters: releaseSpeakingSession.filters,
          },
          {
            path: editSpeakingSession.path,
            element: <EditSpeakingSession />,
            filters: editSpeakingSession.filters,
          },
          {
            path: removeSpeakingSession.path,
            element: <RemoveSpeakingSession />,
            filters: removeSpeakingSession.filters,
          },
          {
            path: removeSpeakingSessionRoom.path,
            element: <RemoveSpeakingSessionRoom />,
            filters: removeSpeakingSessionRoom.filters,
          },
        ],
      },
    ],
  },
  {
    path: lrwSessions.absolutePath,
    breadcrumb: { text: 'Listening, Reading, Writing sessions' },
    element: <Outlet />,
    children: [
      {
        path: lrwSessions.path,

        element: (
          <>
            <Outlet />
            <LrwSessions />
          </>
        ),
        filters: lrwSessions.filters,
        children: [
          {
            path: createLrwSession.path,
            element: <CreateLrwSession />,
            filters: createLrwSession.filters,
          },
        ],
      },

      {
        path: lrwSessionDetails.path,
        breadcrumb: { text: 'View LRW session' },
        element: <LrwSessionDetails />,
        filters: lrwSessionDetails.filters,
        children: [
          {
            path: linkSpeakingSession.path,
            element: <LinkSpeakingSession />,
            filters: linkSpeakingSession.filters,
          },
          {
            path: addRoomToLrwSession.path,
            element: <AddRoomToLrwSession />,
            filters: addRoomToLrwSession.filters,
          },
          {
            path: releaseLrwSession.path,
            element: <ReleaseLrwSession />,
            filters: releaseLrwSession.filters,
          },
          {
            path: releaseLrwWithSpeakingSessions.path,
            element: <ReleaseLrwWithSpeakingSession />,
            filters: releaseLrwWithSpeakingSessions.filters,
          },
          {
            path: editLrwSession.path,
            element: <EditLrwSession />,
            filters: editLrwSession.filters,
          },
          {
            path: removeLrwSession.path,
            element: <RemoveLrwSession />,
            filters: removeLrwSession.filters,
          },
          {
            path: removeLrwSessionRoom.path,
            element: <RemoveLrwSessionRoom />,
            filters: removeLrwSessionRoom.filters,
          },
        ],
      },
    ],
  },
  { path: '*', element: <NotFound /> },
];
